module.exports = "app-ponto-table .geo-content__row {\n  padding: 0;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/viagens/deslocamentos/delocamento-detail/delocamento-detail.component.css
 ** module id = 659
 ** module chunks = 0
 **/